import { isValid } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

const DEFAULT_DATE_FORMAT = 'dd-MM-yyyy';
export const DEFAULT_DATE_TIME_FORMAT = 'dd-MM-yyyy HH:mm';

export const formatDate = (date: string, dateFormat = DEFAULT_DATE_FORMAT) => {
    if (!isValid(new Date(date))) {
        return '';
    }

    return formatInTimeZone(new Date(date), 'UTC', dateFormat);
};

export const isWeekday = (date: Date) => {
    const day = date.getDay();
    const isWeekend = day === 0 || day === 6;
    return !isWeekend;
};
